import * as React from 'react';
import { ISharedDrivesMSBlockerProps } from './types';
import './_SharedDrivesMSBlocker.scss';
import {
    getSharedDrivesMSBlockerAdminText,
    getSharedDrivesMSBlockerFooterText,
    getSharedDrivesMSBlockerLinkText,
    getSharedDrivesMSBlockerText,
    SHARED_DRIVES_MS_BLOCKER_COPIED,
    SHARED_DRIVES_MS_BLOCKER_COPY,
    SHARED_DRIVES_MS_BLOCKER_LINK,
    SHARED_DRIVES_MS_BLOCKER_UPGRADE
} from './constants';
import { Button } from 'kui';
import ReactHtmlParser from 'react-html-parser';

export function SharedDrivesMSBlocker ({
    onClick
}: ISharedDrivesMSBlockerProps) {
    const className = 'shared-drives-ms-blocker';

    const [isCopied, setCopied] = React.useState(false);

    const onCopyClick = (e: React.SyntheticEvent) => {
        if (navigator.clipboard) {
            e.preventDefault();
            navigator.clipboard.writeText(window.location.origin + SHARED_DRIVES_MS_BLOCKER_LINK)
                .then(() => {
                    setCopied(true);
                });
        }
    }

    return (
        <div className={className}>
            <div className={`${className}__text`}>
                <p>
                    {getSharedDrivesMSBlockerText()}
                </p>
                <p>
                    {getSharedDrivesMSBlockerLinkText()}
                    <a
                        className={`${className}__copy ${isCopied ? 'copied' : ''}`}
                        href={SHARED_DRIVES_MS_BLOCKER_LINK}
                        target={'_blank'}
                        onClick={onCopyClick}
                    >
                        {ReactHtmlParser(isCopied ? SHARED_DRIVES_MS_BLOCKER_COPIED : SHARED_DRIVES_MS_BLOCKER_COPY)}
                    </a>
                </p>
                <p className={`${className}__text ${className}__text--important`}>
                    {getSharedDrivesMSBlockerAdminText()}
                </p>
            </div>
            <div className={`${className}__buttons`}>
                <Button
                    size={'large'}
                    onClick={onClick}
                >
                    {SHARED_DRIVES_MS_BLOCKER_UPGRADE}
                </Button>
            </div>
            <div className={`${className}__text`}>
                {ReactHtmlParser(getSharedDrivesMSBlockerFooterText())}
            </div>
        </div>
    )
};
